// In-app links into the institution admin console.
//
// The console used to be a standalone SPA on its own port; it now lives inside
// this same consumer app under the /institution/* route tree (single origin,
// single port). The /for-institutions marketing CTAs use these helpers, so they
// resolve to in-app paths — clicking "Get started" / "Log in" enters the console
// on the same origin instead of a dead cross-port link.
export const INSTITUTION_APP_URL = '/institution';

export const institutionSignupUrl = () => `${INSTITUTION_APP_URL}/signup`;
export const institutionLoginUrl = () => `${INSTITUTION_APP_URL}/login`;
